import React from "react";
import { useSelector } from "react-redux";

import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { Stack } from "@fluentui/react/lib/Stack";
import { XboxSpinner } from "@gamedev-web/gamedev-sdk-core";

import { Programs } from "../../models/programsConfig";
import { getCurrentProgram } from "../../redux/selectors";

export const LoadingSpinner = () => {
  const currentProgram = useSelector(getCurrentProgram);

  const programSpinner = () => {
    switch (currentProgram) {
      case Programs.IdAzure:
        return (
          <Stack>
            <Spinner size={SpinnerSize.large} />
          </Stack>
        );
      default:
        return <XboxSpinner />;
    }
  };
  return programSpinner();
};
